import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_Resource } from '@app/hcs-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_Resource } from '../../../_entity.js';
import { Renderer_ResourceHeader } from './renderers/Renderer_ResourceHeader/Renderer_ResourceHeader.js';
import { Editor_Resource } from './renderers/Editor_Resource/Editor_Resource.js';
import './Manager_Resource.scss';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
const Editor_Resource_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-resource', children: [_jsx(Renderer_ResourceHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_Resource, { editable: props.editable, editMode: props.renderArgs.editMode, isNewResource: props.renderArgs.itemId.startsWith('###NEWITEM###') })] });
export const Manager_Resource = createWorkHubManager({
    module: ModuleFE_Resource,
    dbDef: DBDef_Resource,
    defaultItem: {},
    labelResolver: (item) => item.label ?? 'New Resource',
    EditorComponent: Editor_Resource_Wrapper,
});
//# sourceMappingURL=Manager_Resource.js.map